import React from 'react';
import NextImage, { StaticImageData } from 'next/image';

import type { Props as LinkProps } from 'Elements/Link/Link';
import LinkArrow from 'Elements/Link/Arrow/Arrow';

import { Container, ImageWrapper, Content } from './Campaign.styled';

export interface Props {
    image: {
        alt?: string;
        src: StaticImageData | string;
    };
    description: string;
    link: LinkProps;
    backgroundColor?: string;
}

const Campaign: React.FC<Props> = props => {
    const { image, description, link, backgroundColor } = props;

    return (
        <Container $backgroundColor={backgroundColor}>
            <ImageWrapper>
                <NextImage
                    src={image.src}
                    alt={image.alt || ''}
                    fill
                    style={{ objectFit: 'contain', objectPosition: 'center' }}
                />
            </ImageWrapper>
            <Content>
                <p>{description}</p>
                <LinkArrow {...link} />
            </Content>
        </Container>
    );
};

export default Campaign;
